import type { Hall } from '../types'

/**
 * Salon renkleri (22 Eki 2026): Masa Yönetimi'ndeki sekmeler, garsonun Masa
 * Seç penceresi ve kasadaki masa ızgarası aynı rengi gösteriyor. Ayarlar
 * kartlarının tonları, salon sırasına göre dönüyor; salonsuz masalar gri.
 * SettingsPage'deki `.tone--*` sınıfları da bu sırada.
 */
export const HALL_TONES = ['brand', 'blue', 'green', 'violet', 'amber'] as const
export type HallTone = (typeof HALL_TONES)[number] | 'slate'

const HEX: Record<HallTone, string> = {
  brand: 'var(--brand)',
  blue: '#2a78d6',
  green: '#22a06b',
  violet: '#7c5cd6',
  amber: '#e0a100',
  slate: '#64748b',
}

/** Salonun ton adı; `null` ya da bilinmeyen salon gri. */
export function hallTone(hallId: string | null | undefined, halls: Pick<Hall, 'id'>[]): HallTone {
  const i = hallId ? halls.findIndex((h) => h.id === hallId) : -1
  return i < 0 ? 'slate' : HALL_TONES[i % HALL_TONES.length]
}

/** CSS'te kullanılacak renk değeri. */
export function hallColor(hallId: string | null | undefined, halls: Pick<Hall, 'id'>[]): string {
  return HEX[hallTone(hallId, halls)]
}
